import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Button,
  InputLabel,
  Grid,
  TextField,
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchTrainerByEmail } from "../../../Actions";
import { CustomGreenButton} from "../../Button/CustomButton";
import { StyledDivider } from "../../Divider/StyledDivider";
import validators from "../../../Utils/Validators";
import { Link } from "react-router-dom";
import NotFoundImage from "../../../Assets/NotFound/search-not-found.gif";
import { colors } from "../../../Styles/GlobalStyles/Variables";

const Part1 = ({
  styleClasses,
  grayedOutStyles,
  handleNext,
  emailValue,
setEmailValue,
setEmailHasValue
}) => {
    const dispatch = useDispatch();
    const trainersReducer = (state) => state.trainersReducer;
    const { trainingCenterDetails, centerLoading } = useSelector(trainersReducer);
   
    const [formStates, setFormStates] = useState({
        emailAddressError: false,
        emailAddressErrorMsg: "",
    });
    const handleBlurEmail = (event) => {
        let newValue = event.target.value;
        newValue = event.target.value.trim();
        if (!validators.isValidEmail(newValue)) {
          setFormStates({
            ...formStates,
            emailAddressError: true,
            emailAddressErrorMsg:
              "Please enter a valid email",
          });
          return false;
        }
        setFormStates({
          ...formStates,
          emailAddressError: false,
          emailAddressErrorMsg: "",
        });
      };
  const handleSubmit = () => {
    if (emailValue.trim() === '' || !validators.isValidEmail(emailValue.trim())) {
      setFormStates({
        ...formStates,
        emailAddressError: true,
        emailAddressErrorMsg: "Please enter a valid email",
      });
      return;
    }

    dispatch(fetchTrainerByEmail(emailValue));
    setEmailHasValue(true);
  };

  return (
    <>
      <Box >
        <Typography 
        style={{
            fontStyle: "italic",
            color: "#1d1d1d",
            margin: "15px 0px 5px 0px ",
          }}
        >
        Please enter your centre's email address
        </Typography>
        <FormControl variant="outlined" fullWidth>
          <OutlinedInput
                name="email"
                placeholder="Email Address"
                id="outlined-adornment-email"
                size="medium"
                endAdornment={<InputAdornment position="end">@</InputAdornment>}
                aria-describedby="outlined-email-helper-text"
                inputProps={{
                  "aria-label": "email",
                  autoComplete: "email",
                }}
                onBlur={handleBlurEmail}
                value={emailValue}
                onChange={(e) => setEmailValue(e.target.value)}
                error={formStates.emailAddressError}
              />
              <FormHelperText error id="accountId-error">
                {formStates.emailAddressErrorMsg}
              </FormHelperText>
         </FormControl>
          <FormControl fullWidth sx={{ margin: "20px 0px" }}>
              <CustomGreenButton
                fullWidth
                sx={{ padding: "10px" }}
                onClick={handleSubmit}
              >
                 {centerLoading ? (
                <CircularProgress color="inherit" />
              ) : (
                "Find"
              )}
              </CustomGreenButton>
            </FormControl>
      </Box>

      {
          !centerLoading &&
          trainingCenterDetails !== null &&
          Object.keys(trainingCenterDetails).length > 0 ? (
        <Box sx={{marginY: "20px"}}>
        <StyledDivider textAlign="left" >
                  <Typography variant="subtitle2" sx={{ color: "#949494" }}>
                    Biodata of Training Centre
                  </Typography>
                </StyledDivider>
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">Name of Centre</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainingCenterDetails?.skillCenterName}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">
              Centre Email Address
            </InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainingCenterDetails?.centerEmail}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">Phone Number</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainingCenterDetails?.centerPhoneNumber}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">Whatsapp Number</InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainingCenterDetails?.centerWhatsappNumber}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">State</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainingCenterDetails?.state || ""}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">LGA</InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainingCenterDetails?.lga || ""}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="type-of-training">Full Address</InputLabel>
            <TextField
              id="type-of-training"
              variant="outlined"
              value={trainingCenterDetails?.physicalAddress}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box style={styleClasses.labelContainer}>
            <InputLabel style={styleClasses.labelText} htmlFor="skills-taught">Landmark(s)</InputLabel>
            <TextField
              id="skills-taught"
              variant="outlined"
              value={trainingCenterDetails?.closeLandMark}
              style={grayedOutStyles}
              fullWidth
              readonly
              size="small"
            />
          </Box>
        </Grid>
      </Grid>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
        }}
      >
        <Button sx={{textTransform: "inherit",}} variant="contained" color="primary" onClick={handleNext}>
          Continue
        </Button>
      </div>
      </Box>
          )
          // : centerLoading && Object.keys(trainingCenterDetails).length === 0 ? (
          //   <Box
          //     mb={2}
          //     sx={{ width: "100%", display: "flex", justifyContent: "center" }}
          //   >
          //     <div style={{textAlign:'center', textTransform:'initial'}}>
          //       <img
          //         height={150}
          //         width={150}
          //         src={NotFoundImage}
          //         alt="Training centre not found."
          //       />
          //       <Typography variant="body2" >
          //         Training center not found. Ensure you are inputing your registered email. <br/> If you haven't registered before, click on the link below to do so. <br/>
          //       </Typography>
          //       <Link to="/trainingCentreRegistration" >
          //         <p style={{color: "#666666",
          //   textDecoration: "underline", fontSize: "small", marginTop: "5px" }}>
          //         Fresh Registration
          //         </p>
          //       </Link>
          //     </div>
          //   </Box>
          // ) 
          : (
            <Box sx={{ height: "300px" }}></Box>
          )}
    </>
  );
};

export default Part1;
